import React from "react";

export function Tags() {
  return (
    <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_di_931_9586)">
        <g clip-path="url(#clip0_931_9586)">
          <rect x="1" width="40" height="40" rx="12" fill="url(#paint0_linear_931_9586)" />
          <g filter="url(#filter1_dd_931_9586)">
            <path d="M31.1941 17.0231L22.1771 8.0061L13.9001 8.9031L14.1151 10.8911L21.4401 10.0981L29.7801 18.4371C30.0761 18.7331 30.0761 19.2141 29.7681 19.5211L28.8061 20.5151L20.0991 11.8081L10.9621 13.0571L9.95312 22.1801L18.9661 31.1921C19.4871 31.7131 20.1791 32.0001 20.9161 32.0001C21.6531 32.0001 22.3461 31.7131 22.8781 31.1811L29.1221 24.7321C29.7871 24.0671 30.0381 23.1441 29.8811 22.2811L31.1951 20.9241C32.2701 19.8481 32.2691 18.0981 31.1941 17.0231ZM15.0001 18.0001C14.4481 18.0001 14.0001 17.5521 14.0001 17.0001C14.0001 16.4481 14.4481 16.0001 15.0001 16.0001C15.5521 16.0001 16.0001 16.4481 16.0001 17.0001C16.0001 17.5521 15.5521 18.0001 15.0001 18.0001Z" fill="url(#paint1_linear_931_9586)" />
          </g>
        </g>
      </g>
      <defs>
        <filter id="filter0_di_931_9586" x="0.5" y="0" width="41" height="41" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_931_9586" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_931_9586" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_931_9586" />
        </filter>
        <filter id="filter1_dd_931_9586" x="-21" y="-18.1015" width="84" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_931_9586" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3.89851" />
          <feGaussianBlur stdDeviation="15" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_931_9586" result="effect2_dropShadow_931_9586" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_931_9586" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_931_9586" x1="21" y1="0" x2="21" y2="40" gradientUnits="userSpaceOnUse">
          <stop stop-color="#29282C" />
          <stop offset="1" stop-color="#100F11" />
        </linearGradient>
        <linearGradient id="paint1_linear_931_9586" x1="9.78277" y1="3.07613" x2="27.6896" y2="27.1947" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0.65" />
        </linearGradient>
        <clipPath id="clip0_931_9586">
          <rect x="1" width="40" height="40" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}